<template>
  <div class="ma-2 ml-3 site_content">
    <div class="flex s-bt mb-flex">
      <comboFarm
        @fromFarm="farmInfo"
      />

      <div class="weather_info">
        <div class="current-container">
            <div class="current-date">
              <div>오늘</div>
              <!-- <div>{{ todayDate }}</div> -->
            </div>


            <div class="flex weather-info">
              <img class="weather-icon" :src="require('@/assets/monitoring/Weather/' + current.weather_icon + '.svg')" />
              <div class="weather-text">{{ current.weather_content }}</div>
            </div>

            <div class="degree-content">
              <div class="cur_info">{{ current.temp }} 
                <span class="info_unit">°C</span>
              </div>
              <div class="highlow_temp">
                <span class="blue-text">{{ current.lowest_temp }} </span>
                <span class="info_unit blue-text">°C</span>
                <span class="ml-1 mr-1">/</span>
                <span class="red-text">{{ current.highest_temp }}</span>
                <span class="info_unit red-text">°C</span>
              </div>
            </div>

            <div class="feel-content">
              <div class="small-text mb-1">체감</div>
              <div  class="cur_info">{{ current.feel }} <span class="info_unit">°C</span></div>
            </div>

            <div class="wind-section">
              <div class="wind-content flex">
                <img :src="icon_windy" class="mr-1 mb-icon" />
                <div class="cur_info mr-1"> {{ current.wind.speed }} </div>
                <span class="unit">m/s</span>
                <span class="ml-2 mr-2 bold-text"> | </span>
                <div> {{ getdirectionOnly(current.wind.deg) }} </div>
              </div>
            </div>

            <div class="press-section mt-1">
              <div class="press-content flex col">
                <div class="flex">
                  <div class="wind-icon ml-2">
                    <img :src="icon_humi" class="mb-icon" />
                  </div>
                
                  <span class="bold-text wind-text ml-1">{{ current.hum }}</span>
                  <span class="unit">%</span>
                </div>

                <div class="flex">
                  <div class="wind-icon ml-1">
                    <img :src="icon_press" class="mb-icon"/>
                  </div>
                  <span class="bold-text wind-text ml-1">{{ current.wind.ps }}</span>
                  <span class="unit">hPa</span>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>

    <div class="weather-chart">
      <v-tabs
          v-model="tab"
          color="#005B96"
          class="weather-tab"
        >
          <v-tab class="custom-tab">온도</v-tab>
          <v-tab class="custom-tab">습도</v-tab>
          <v-tab class="custom-tab">풍속</v-tab>
          <v-tab class="custom-tab">강수확률</v-tab>
          <v-tab class="custom-tab">강수량</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" class="mt-1 tab-content">
          <v-tab-item v-for="(data, index) in chartData" :key="index">
            <Chart 
              chartType="Line"
              :chartData="data"
              :chartOptions="weatherLine"
              :chartSize="chartSize" 
            />
          </v-tab-item>
          
        </v-tabs-items>
    </div>
    
    <div class="forecast_container vertical-center">
      <div v-for="(weather , w) in forecast" :key="w"  class="forecast_info shadow">
        <div style="font-weight:600; font-size:18px; letter-spacing: -1px;">{{ changeWeek(weather.search_date) }}</div>
        
        <div class="current_icon">
          <img :src="require('@/assets/monitoring/Weather/' + weather.weather_icon + '.svg')" />
        </div>

        <div class="forecast flex vertical-center">
          <div class="avg_temp">
            {{ weather.temp}}℃
          </div>
          <div class="ml-1 mr-1"></div>
          
          <div class="flex">
            <div class="high_temp red-text" style="font-size:13px;"> 
            <!-- <span class="forecast-text">평균</span> -->
              <span>{{ weather.highest_temp }}℃ </span>
            </div>
            <div class="ml-1 mr-1 mt-1"  style="font-size:11px;">/</div>
            <div class="low_temp blue-text"  style="font-size:13px;">
              <!-- <span class="forecast-text">최저</span> -->
              <span>{{ weather.lowest_temp }}℃ </span>
            </div>
          </div>
       
        </div>
      </div>
    </div>

    <div class="vertical-center picker-container">
      <datePicker
        :fr_date="fr_date" 
        :to_date="to_date" 
        @update:fr_date="updateFrDate"
        @update:to_date="updateToDate"
        @refresh="Dailyrefresh" 
      />
    </div>

    <div class="pastWeather_info">
      <v-data-table dense v-resize="onResize"
        class="table_content v-data-table"
        fixed-header
        :footer-props="{
          itemsPerPageOptions:[-1]
        }"
        :loading="loading" 
        :headers="headers"
        :items-per-page="-1" 
        :items="dailyData"
        no-data-text="측정된 자료가 없습니다."
        item-key="checkDate"
        single-select
        :sort-by= "['checkDate']"
        :sort-desc= "[true]"
        hide-default-footer
        style="height:100%;"
        >
        <template v-slot:item= "{ item }">
          <tr v-if="!isMobile" >
            <td>{{ item.checkDate }}</td>
            <td>
              <span>{{ item.w_temp_average }}℃ </span>
              <span style="font-size:13px;" class="red-text">( {{ item.w_temp_highest }}℃ / </span>
              <span style="font-size:13px;" class="blue-text">{{ item.w_temp_lowest }}℃ )</span>
            </td>
            <td>{{ item.w_ps_average }} hPa</td>
            <td>{{ item.w_ws_average }} m/s 
              <span class="blue-text ml-3"> {{ getdirection(item.w_wd_average) }}  </span>
            </td>
            <td>{{ item.w_hum_average }} %</td>
          </tr>

          <tr v-else class="mobile_tr">
            <td class="mb_table">
              <div class="date mt-2">
								<div class="flex-title"> 날짜</div>
								<div> {{ item.checkDate }}</div>
							</div>

              <div class="flex">
                  <div class="flex-title weight"></div>
                  <div class="flex s-bt">
                    <div class="flex-content">
                      <div class="weight">평균</div>
                      <div> {{ item.w_temp_average }} ℃   </div>
                    </div>

                    <div class="flex-content">
                      <div class="weight">최고</div>
                      <div> {{ item.w_temp_highest }} ℃   </div>
                    </div>

                    <div class="flex-content">
                      <div class="weight">최저</div>
                      <div> {{ item.w_temp_lowest }} ℃   </div>
                    </div>
                </div>
              </div>
                
              <div class="line-table"></div>

              <div class="flex s-bt">
                <div class="flex-title weight">기압</div>

                <div class="flex">
                  <div class="flex-content">
                    <div class="weight"></div>
                    <div>  {{ item.w_ps_average }} hPa  </div>
                  </div> 
                </div>
              </div>

              <div class="line-table"></div>

              <div class="flex s-bt">
                <div class="flex-title weight">바람</div>

                <div class="flex">
                  <div class="flex-content">
                    <div class="weight"></div>
                    <div>  {{ item.w_ws_average }} m/s {{getdirection(item.w_wd_average)}} </div>
                  </div> 
                </div>
              </div>

              <div class="line-table"></div>

              <div class="flex s-bt">
                <div class="flex-title weight">습도</div>

                <div class="flex">
                  <div class="flex-content">
                    <div class="weight"></div>
                    <div>  {{ item.w_hum_average }} % </div>
                  </div> 
                </div>
              </div>
              
            </td>
          </tr>

        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import Apis from '@/api/apis'
import Common from "@/utils/custom/common.js";
import dateUtil from "@/utils/custom/dateProperty.js";

import comboFarm from "@/components/combo/farm.vue";
import datePicker from "@/components/compo/datePicker_day.vue";
import Chart from "@/components/chart/Chart.vue"
import { weatherLine } from "@/components/chart/option.js"; 

export default {
  name: 'Weather',
  components:{
    Chart,
    datePicker,
    comboFarm,
  },
  data() {
    return {
      farmData: { company: {}, farm: {} },
      current: { wind:{speed:''}},
      tab: 0,
      weatherLine:weatherLine,
      loading:false,

      icon_windy: require("@/assets/monitoring/icon/windy_dash.svg"),
      icon_humi: require("@/assets/monitoring/icon/humi_dash.svg"),
      icon_press: require("@/assets/monitoring/icon/press_dash.svg"),

      chartData: [], 
      hourlyItems: {},

      forecast : [],

      chartSize: {
        height:'250px',
        width: '83vw',
      },

      fr_date:"",
      menu:false,
      to_date: "",
      menu2: false,

      dailyData:[],
      headers: [
        { text: '날짜', sortable: true, value: 'checkDate' },
        { text: '온도', value: 'w_temp_average' },
        { text: '기압', value: 'w_ps_average' },
        { text: '풍속', value: 'w_ws_average' },
        { text: '습도', value: 'w_hum_average' },
      ],
    }
  },
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 

    let cdate = new Date();
    this.to_date= dateUtil.format(cdate, "yyyy-MM-dd");
    let frdate = new Date(cdate.setDate(cdate.getDate() - 30));
    this.fr_date= dateUtil.format(frdate, "yyyy-MM-dd");

  },
  watch:{
    hourlyItems: {
      handler(newVal) {
        this.chartData = [
          this.forcastChart('온도', newVal.temp, '#ADC0F6', "rgba(173, 192, 246, 0.1)"),
          this.forcastChart('습도', newVal.hum, '#80BCBD', "rgba(128, 188, 189, 0.1)"),
          this.forcastChart('풍속', newVal.wind_speed, '#73D6FF', "rgba(115, 214, 255, 0.1)"),
          this.forcastChart('강수확률', newVal.rain_pop, '#D4E7FF', "rgba(212, 231, 255, 0.1)"),
          this.forcastChart('강수량', newVal.rain_1h, '#D6EDEB', "rgba(214, 237, 235, 0.1)")
        ];
      },
      deep: true
    }
  },
  methods:{
    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
    farmInfo(data){
      // console.log(data)
      this.farmData = data;
      this.refresh();
      this.Dailyrefresh();
    },
    updateFrDate(date) {
      this.fr_date = date;
    },
    updateToDate(date) {
      this.to_date = date;
    },
    refresh(){
      this.$store.commit("resMessage","");
      // this.loading = true;

      Apis.weatherForecast({
        farm_cd : this.farmData.farm.code,
      },(res) => {  
        if (res.result) {
        this.current = res.data.current;

        this.forecast = res.data.forecast;
        this.hourly = res.data.hourly;

        let search_date = [];
        let temp = [];
        let hum = [];
        let wind_speed = [];
        let rain_pop = [];
        let rain_1h = [];

        this.hourly.forEach(function (item){
          search_date.push(item.search_date);
          temp.push(parseFloat(item.temp));
          hum.push(item.hum);
          wind_speed.push(item.wind.speed);
          rain_pop.push(item.rain_pop);
          !isNaN(item.rain_1h) && rain_1h.push( Number(item.rain_1h)) || rain_1h.push(null);
        })

        this.hourlyItems = {
          search_date:search_date,
          temp:temp,
          hum:hum,
          wind_speed:wind_speed,
          rain_pop:rain_pop,
          rain_1h:rain_1h
        }

        // this.humData = this.HumChart();
        // console.log(this.hourlyItems)

        this.$store.commit("resMessage",res.message);
      } else {
        alert(res.message);
      }
      this.loading = false;
      }).catch( (err) => {  // API 오류 처리
        console.log("weatherForecast API 호출 오류",err)
        this.loading = false;
      })
    },
    forcastChart(label,value,color,bgColor){
      return{
        labels: this.hourlyItems.search_date,
        datasets:[
          {
            label:label,
            data:value,
            borderColor: color,
            backgroundColor: bgColor 
          }
        ]
      }
    },
    Dailyrefresh(){
      this.$store.commit("resMessage","");
      this.loading = true;

      Apis.weatherDataDailyView({
        farm_cd : this.farmData.farm.code,
        fr_date : this.fr_date,
        to_date : this.to_date
      },(res) => {  
        if (res.result) {
        this.dailyData = res.data;

        // console.log(res.data)

      } else {
        alert(res.message);
      }
      this.loading = false;
      }).catch( (err) => {  // API 오류 처리
        console.log("weatherForecast API 호출 오류",err)
        this.loading = false;
      })
    },
    changeWeek(cdate){
      const datePart = cdate.substring(0, 10);
      const date = new Date(datePart + "T00:00:00");

      const daysOfWeek = ["일", "월", "화", "수", "목", "금", "토"];

      const dayOfWeek = daysOfWeek[date.getDay()];

      return `${datePart.substring(5,10)} ${dayOfWeek}`;

      // console.log(changeWeek(cdate)); // "2024-08-18, 일요일"

    },
    getdirection(item){
      return Common.getDirection(item);
    },
    getdirectionOnly(item){
      return Common.getDirectionOnly(item);
    },
  }

}
</script>

<style scoped lang="scss">
@import '../../style/base.scss';
@import '../../style/table_mb.scss';

.weather_info{
  width:50vw;
}
// 현재날씨
.current-container{
  border-radius: 30px;
  background: #FFFFFF;
  box-shadow: 0px 0.5px 4px rgba(0, 0, 0, 0.25);
  display: flex; 
  width: 100%; 
  max-width:600px;
  height: 55px;
  align-items: center;
  justify-content: space-evenly; /* 자식 요소들을 균등하게 배치 */
  margin: 0 auto;
  line-height: 15px;
}
.current-date{
  text-align: center;
  font-size:0.9rem;
  font-weight:$semibold-weight;
  min-width:10%;
}
.weather-icon{
  width: 2.5rem; /* 이미지 크기를 줄임 */
  height: 2.5rem; /* 이미지 크기를 명시적으로 지정 */
}

.weather-info{
  min-width:18%;
  justify-content: center;
  align-items: center;
}
.degree-content{
  min-width:15%;
  text-align: center;
}
.feel-content{
  min-width:12%;
  text-align: center;
}
.degree-content .cur_info{
  font-size:1.1rem;
  font-weight:$bold-weight;
}
.highlow_temp{
  font-size:0.8rem;
  letter-spacing: -1px;
  font-weight:$semibold-weight;
}
.small-text{
  font-size:$small-font !important;
  margin-right:5px;
}
.bold-text{
  font-weight:$bold-weight;
  font-size:13px !important;
}
.info_unit{
  vertical-align:top;
  font-size:0.7rem;
}

.forecast-container {
  width: 100%;
  max-width: 35vw; 
  overflow-x: hidden; 
}
.forecast-content {
  display: flex;
  justify-content: center; 
  width: 100%;
  overflow-x: scroll;
  margin-top: 1.5rem;
}

.forecast_info {
  border: 1px solid #005B96;
  box-shadow: 0px 0.5px 5px rgba(0, 0, 0, 0.25);
  border-radius: 7px;
  width:14%;
  margin-left:10px;
  height:100px;
  text-align: center;
  display: flex;
  justify-content: center;
}

.date-text{
  font-weight:$bold-weight;
  font-size:0.9rem;
  letter-spacing: -1.25px;
}
.forecast_icon img{
  width:2.8rem;
  height:2.8rem;
}
.forecast_degree{
  display:flex;
  justify-content: center;
}
.degree_info{
  font-size:0.8rem !important;
  letter-spacing: -1px;
}
.wind-section{
  min-width:20%;
  justify-content: center;
}
.press-section{
  min-width:18%;
}
.press-content{
  justify-content: left;
}
.wind-content{
  align-items: center;
}
.wind-icon{
  width:20px;
  height:20px;
}
.wind-text{
  width:35px;
  text-align: left;
}

//차트
.weather-chart{
  margin-top:10px;
}
.custom-tab{
 width:10vw !important;
 font-weight:$bold-weight;
 letter-spacing: -0.75px;
 font-size:0.9rem;
}
.tab-content{
  min-width:100%;
  min-height:300px !important;
  max-height:350px !important;
  border-radius: 5px;
  border: 1px solid #D5D5D5;
  padding:20px;
}

// 예보
.forecast_container{
  margin-top:10px;
}
.forecast_info{
  min-width:120px;
  max-width:200px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 7px;
  border:none !important;
}
.current_icon{
  width:45px;
  height:45px;
}
.forecast{
  font-size:0.9rem;
  letter-spacing: -0.75px;
}

//데이피커
.picker-container{
  margin-top:10px;
  display:flex;
  justify-content: center;
}

.refresh_btn{
  margin-top:-20px !important;
}
.pastWeather_info {
  height: 35vh;
  margin-top: 5px;
  border-radius: 9px !important;
}

::v-deep .v-data-table__wrapper {
  max-height: 100% !important;  // 내부 최대 높이 제한
  overflow-y: auto !important;  // 스크롤 담당은 여기서
  background-color: white !important;
  border-radius: 9px;
}
// 모바일
@media only screen and (max-width: 768px) {
  .site_content{
    display:block !important;
  }
  .site_content .mb-flex{
    flex-direction: column;
  }
  .weather_info{
    width:85vw !important;
    min-width:360px !important;
    margin:0 auto !important;
    margin-top: 10px !important;
  }
  .feel-content{
    display: none;
  }
  .current-date{
    display: none;
  }
  .weather-info{
    min-width:10%;
  }
  .wind-content .flex{
    flex-direction: row !important; 
  }
  .custom-tab{
    width:20px !important;
  }
  .weather-tab{
    width:300px;
  }
  .tab-content{
    width:100%;
    min-width:360px !important;
    max-width:380px !important;
  }
  .forecast_container{
    flex-wrap: wrap;
    justify-content: center;
  }
  .forecast_info{
    text-align: center;
    width:250px !important;
    margin-top:10px !important;
  }
  .forecast-text, .weather-text{
    display: none;
  }
  .forecast_info:last-child {
    display:none !important;
  }
  .v-data-table-header-mobile__wrapper .v-select{
    display: none !important;
  }
}

</style>